import Avatar from './avatar';

export { Avatar };
